import React from 'react';

import { trans, getPagePath } from '@spotahome/soyuz/client';

import { HeaderContainer } from '@spotahome/ui-library';

import Hero from '@spotahome/landings-common/src/components/Hero';
import OtherCityImage from '@spotahome/landings-common/src/components/icons/OtherCityImage';

import './ErrorReferral.scss';

const ErrorReferral = () => {
  const buttonRedirection = getPagePath('landing');

  return (
    <div data-test="referee.error.container">
      <Hero
        menu={
          <HeaderContainer
            locales={{ current: 'en' }}
            login={false}
            showMobileMenu={false}
            links={{
              home: false,
              listYourProperty: false,
              howItWorks: false,
              favorites: false
            }}
          />
        }
        title={trans('referee.landing.error.title')}
        subtitle={`${trans(
          'referee.landing.error.message.codeNotValid'
        )} ${trans('referee.landing.error.message.checkOurProperties')}`}
        size="big"
        colorTitle="dark"
        colorSubtitle="dark"
        isRowAlignContent
        className="referee__wrapper--fit"
        callToActionText={trans('referee.landing.error.cta')}
        callToActionPath={buttonRedirection}
        image={<OtherCityImage className="error-page__image" />}
        dataTest="referee.error.btn.redirect"
      />
    </div>
  );
};

export default ErrorReferral;
